/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';
import { fg } from '@atlassian/jira-feature-gating';

export const useSelectedConfigTab = (): {
	getSelectedConfigTab: () => string;
	setSelectedConfigTab: (newConfigTab: string) => void;
} => {
	const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';

	const getSelectedConfigTab = (): string => {
		if (fg('jfp-vulcan-browser-storage-migration')) {
			return AtlBrowserStorageLocal.getItem(SELECTED_CONFIG_TAB_KEY) || '';
		}
		// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
		return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
	};

	const setSelectedConfigTab = (newConfigTab: string): void => {
		if (fg('jfp-vulcan-browser-storage-migration')) {
			// @browser-storage setter
			AtlBrowserStorageLocal.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
		} else {
			// eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
			localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
		}
	};

	return { getSelectedConfigTab, setSelectedConfigTab };
};
